import React from 'react';
import { NavLink } from 'react-router-dom';
import { BrainCircuit, Database, PenSquare } from 'lucide-react';

interface Tile {
  to: string;
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  body: string;
}

const tiles: Tile[] = [
  {
    to: '/v4/go-lab/intelligence',
    icon: BrainCircuit,
    title: 'Intelligence',
    body: 'Manage taxonomies and prompts that power classification.',
  },
  {
    to: '/v4/go-lab/datasets',
    icon: Database,
    title: 'Datasets',
    body: 'Curate gold datasets for evaluation and training.',
  },
  {
    to: '/v4/go-lab/annotate',
    icon: PenSquare,
    title: 'Annotate',
    body: 'Label and review records with two-pass annotation. (Coming soon.)',
  },
];

const HomePage: React.FC = () => (
  <div className="flex h-full flex-col bg-[var(--go-spring)] px-4 py-4 md:px-6 md:py-6 xl:px-8 xl:py-6">
    <div className="space-y-2">
      <h1 className="font-jakarta text-3xl font-extrabold tracking-[-0.04em] text-foreground md:text-4xl">
        GO Lab
      </h1>
      <p className="max-w-3xl text-[13px] leading-[1.7] text-muted-foreground">
        Tools for building, evaluating, and curating Good Outcomes intelligence.
      </p>
    </div>
    <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
      {tiles.map(({ to, icon: Icon, title, body }) => (
        <NavLink
          key={to}
          to={to}
          className="rounded-2xl border border-border/70 bg-card p-6 shadow-[var(--shadow-card)] transition-colors hover:border-primary/15"
        >
          <Icon className="h-5 w-5 text-primary" />
          <h2 className="mt-3 font-jakarta text-lg font-bold text-foreground">{title}</h2>
          <p className="mt-1 text-[13px] leading-[1.7] text-muted-foreground">{body}</p>
        </NavLink>
      ))}
    </div>
  </div>
);

export default HomePage;
